module.exports = __webpack_public_path__ + "img/icon-brands.82999f7a.svg";